import { InternalToolsIndexRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/internal-tools/')({
  component: InternalToolsIndexRoute,
});
